import { ApiGetRequest, EAibGrid, EEecsRegistry, ETypeOfSupport } from 'types';

export enum EEecsCertificateModals {
  DETAILS = 'details',
  COMMENT = 'comment',
}

export interface IEecsCertificateModal {
  type: EEecsCertificateModals;
}

export interface IGoCertificateShorten {
  id: number | string;
  group_id: string;
  production_device_name: string;
  production_device_id: string;
  type_of_installation_code: string;
  type_of_installation_path: string[];
  energy_source_code: string;
  energy_source_code_path: string[];
  comment: string | null;
  volume: number;
  production_year: string;
  type_of_support: ETypeOfSupport;
  aib_grid_connected: EAibGrid;
  country_of_issue: {
    code: string;
    name: string;
  };
  registry: EEecsRegistry;
  _selected_volume?: number;
}

export interface IGoCertificate extends IGoCertificateShorten {
  ids: number[];
  reserved_volume: number;
  on_exchange_quantity: number;
  bundles_list: number[];
  operational_date: string | null;
}

export interface FetchGoCertificatesShortenPayload extends ApiGetRequest {
  filter_by_has_comment?: boolean | null;
  filter_by_production_device_id?: string | null;
  filter_by_production_date?: string | null;
  filter_by_type_of_installation?: string | null;
  filter_by_energy_source?: string | null;
  filter_by_type_of_support?: string | null;
  filter_by_aib_grid_connected?: string | null;
  filter_by_type?: string[] | null;
  filter_by_issue_country?: string[] | null;
  filter_by_status?: string | null;
  filter_by_registry?: string | null;

  order_by_volume?: 'asc' | 'desc';
  order_by_comment?: 'asc' | 'desc';
  order_by_delivery_date?: 'asc' | 'desc';
}

export interface FetchGoCertificatePayload extends FetchGoCertificatesShortenPayload {
  filter_by_has_exchanges?: boolean | null;
  filter_by_prod_start_date?: string | null;
  filter_by_prod_end_date?: string | null;
  filter_by_exp_start_date?: string | null;
  filter_by_exp_end_date?: string | null;
  filter_by_operational_start_date?: number | null;
  filter_by_operational_end_date?: number | null;

  order_by_bundle_id?: 'asc' | 'desc';
  order_by_production_device_name?: 'asc' | 'desc';
}

export interface UpdateGoCertificatePayload {
  group_id?: string;
  comment?: string;
}
